import { createApp } from 'vue';
import { createPinia } from 'pinia'

import LoginApp from '../views/LoginApp.vue';

export default function loadLoginApp(el) {
    createApp(LoginApp).use(createPinia()).mount(el);
}